interface DropdownProps {
  id: string;
  className?: string;
  label?: string;
  showLabel?: boolean;
  required?: boolean;
  children?: React.ReactNode;
  onChange?: (e: any) => void;
  value: string;
  bgColour?: string;
  textColour?: string;
  borderClass?: string;
  placeholderColour?: string;
  width?: string;
}

export default function Dropdown({
  id,
  className = "col-span-full",
  label,
  showLabel,
  required,
  children,
  onChange = () => { },
  value,
  bgColour = "transparent",
  textColour = "dark-grey",
  borderClass = "border border-dark-grey",
  placeholderColour = "dark-grey/50",
  width = "full"
}: DropdownProps) {
  return (
    <div>
      {showLabel ? (
        <label
          htmlFor={id}
          className="mb-3 block text-sm font-medium text-black dark:text-white text-left"
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-black dark:text-white text-left"
        />
      )}
      <div className={className}>
        <select
          id={id}
          className={`block w-${width} appearance-none rounded-full border px-4 py-1 bg-${bgColour} ${borderClass} placeholder-${placeholderColour} text-${textColour} focus:ring-none focus:ring-transparent text-xs sm:text-sm pr-8`}
          required={required}
          onChange={onChange}
          value={value}
        >
          {children}
        </select>
      </div>
    </div>
  );
}